import getImgixUrl from "./getImgixUrl";
import type { ImgixOptions } from "./types";

const IMG_REGEX = /<img\s+[^>]*src="([^"]*)"[^>]*>/gi;

// The device pixel ratio of a retina display.
const DEVICE_PIXEL_RATIO = 2;

const convertToImgixUrls = (campaignHtml?: string): string => {
  const isCampaignHtmlEmpty = !campaignHtml;

  if (isCampaignHtmlEmpty) {
    return "";
  }

  let html = campaignHtml;

  const matches = html.matchAll(IMG_REGEX);
  const imgTags = Array.from(matches, ([ imgTag ]) => imgTag);

  for (const imgTag of imgTags) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = imgTag;

    const imageElement = tempDiv.querySelector("img");
    const { width, height, src: imgUrl } = imageElement;

    const options: ImgixOptions = {
      dpr: DEVICE_PIXEL_RATIO,
    };

    const hasWidth = Boolean(width);

    if (hasWidth) {
      options.w = width;
    }

    const hasHeight = Boolean(height);

    if (hasHeight) {
      options.h = height;
    }

    const imgixUrl = getImgixUrl(imgUrl, options);
    imageElement.src = imgixUrl;

    html = html.replace(imgTag, imageElement.outerHTML);
  }

  return html;
};

export default convertToImgixUrls;
